
import axios from '../shared/axios';
import TemplateHelper from "../Templates/TemplateHelper";


import DefaultWorkflows from '../Templates/DefaultWorkflows';
import DefaultTemplates from '../Templates/DefaultTemplates';


export function saveWorkflowGroups(data) {
    return axios.post('/api/Workflow/SaveWorkflow', data);
}
export function getInstanceDefaultWorkflowGroups() {
    return new Promise((resolve, reject) => {
        axios.get('/api/Workflow/GetWorkflow?workflowid=1')
            .then(result => {
                try {
                    if (result.data && result.data.workflowjson) {
                        const dummyTemplate = { ...DefaultTemplates[0] };
                        dummyTemplate.workflowGroups = JSON.parse(result.data.workflowjson);
                        const sanitizedDummyTemplate = TemplateHelper.templateSanitizer(dummyTemplate);
                        //LETS ADD CONFIG TO OBJECT TO SYSTEM WORKFLOWS CAN BE USED
                        sanitizedDummyTemplate.workflowGroups.forEach(WFG => {
                            const defaultWFG = DefaultWorkflows.find(dwfg => dwfg.id === WFG.id);
                            WFG.workflows.forEach(WF => {
                                const defaultWF = defaultWFG.workflows.find(dwf => dwf.id === WF.id);
                                WF.config = { ...defaultWF.config };
                                WF.description = WF.config.description;// just for list display purposes
                            })
                        });

                        resolve({ data: [...sanitizedDummyTemplate.workflowGroups] });
                    }
                    else {
                        reject("Instance default workflows not found")
                    }
                }
                catch (err) {
                    console.log(err)
                    reject("Error parsing instance default workflows")
                }

            })
            .catch(error => reject(error));
    });
}


export function saveTemplate(data) {
    return axios.post('/api/Template/SaveTemplate', data);
}
export function getTemplates() {
    return axios.post(`/api/Template/LoadTemplatesList`);
}

export function getTemplate(templateid) {
    return new Promise((resolve, reject) => {
        axios.get(`/api/Template/GetTemplate`, { params: { templateid } })
            .then(result => {
                try {
                    if (result.data && result.data.templatejson) {
                        let template = result.data;
                        const baseObj = JSON.parse(template.templatejson);
                        const sanitizedObj = TemplateHelper.templateSanitizer(baseObj);
                        sanitizedObj.templateid = template.templateid;
                        sanitizedObj.name = template.name;
                        resolve({ data: sanitizedObj });
                    }
                    else {
                        reject("Template not found")
                    }
                }
                catch (err) {
                    console.log(err)
                    reject("Error parsingtemplatejson")
                }
            })
            .catch(error => reject(error));
    });
}

export function getDefaultWorkflowGroups() {
    return DefaultWorkflows;
}
export function getDefaultTemplates() {
    return DefaultTemplates;
}

export function getTemplatesToSelectList(companyid) {
    return axios.get(`/api/Template/ToSelectList`, { params: { companyid } });
}